var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
class AxisLine extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "d3scaleExtent", (domain) => {
      const start = domain[0];
      const stop = domain[domain.length - 1];
      return start < stop ? [start, stop] : [stop, start];
    });
    __publicField(this, "d3scaleRange", (scale) => scale.rangeExtent ? scale.rangeExtent() : this.d3scaleExtent(scale.range()));
  }
  render() {
    const {
      orient,
      strokeWidth,
      outerTickSize,
      fill,
      stroke,
      scale
    } = this.props;
    const sign = orient === "top" || orient === "left" ? -1 : 1;
    const range = this.d3scaleRange(scale);
    let d;
    if (orient === "bottom" || orient === "top") {
      d = `M${range[0]},${sign * outerTickSize}V0H${range[1]}V${sign * outerTickSize}`;
    } else {
      d = `M${sign * outerTickSize},${range[0]}H0V${range[1]}H${sign * outerTickSize}`;
    }
    return /* @__PURE__ */ jsx("path", { className: "domain", d, style: {
      shapeRendering: "crispEdges"
    }, fill, stroke, strokeWidth });
  }
}
__publicField(AxisLine, "propTypes", {
  scale: PropTypes.func.isRequired,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  innerTickSize: PropTypes.number,
  outerTickSize: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  tickPadding: PropTypes.number,
  // eslint-disable-next-line zillow/react/forbid-prop-types, zillow/react/no-unused-prop-types
  tickArguments: PropTypes.array,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  orient: PropTypes.string,
  strokeWidth: PropTypes.string
});
__publicField(AxisLine, "defaultProps", {
  innerTickSize: 6,
  outerTickSize: 6,
  tickPadding: 3,
  fill: "none",
  tickArguments: [10],
  // eslint-disable-next-line zillow/react/default-props-match-prop-types
  tickValues: null,
  // eslint-disable-next-line zillow/react/default-props-match-prop-types
  tickFormat: null
});
export {
  AxisLine as default
};
